import React, { useEffect, useRef, useState } from 'react';
import { inject, observer } from 'mobx-react';
import s from './index.less';
import { Tooltip } from '@/components';
import { Icon } from '@/components';
import classNames from 'classnames';
interface PenIconProps {
  title?: string;
  name: string;
  className?: string;
  style?: any;
  onClick?: any;
}

const PenIcon: React.FC<PenIconProps> = inject()(
  observer((props: PenIconProps) => {
    const { title, name, className, style, onClick, ...rest } = props;
    const hoverRef = useRef<any>();

    return (
      <div
        className={classNames(s.wrapper, className)}
        style={style}
        ref={hoverRef}
        onClick={onClick}
      >
        {title ? (
          <Tooltip getPopupContainer={() => hoverRef.current} showArrow title={title}>
            <span {...rest} ref={hoverRef} className={s.hoverIcon}>
              <Icon name={name} size={18} mode="symbol" className={s.icon} />
            </span>
          </Tooltip>
        ) : (
          <span {...rest} ref={hoverRef} className={s.hoverIcon}>
            <Icon name={name} size={18} mode="symbol" className={s.icon} />
          </span>
        )}
      </div>
    );
  })
);

export default PenIcon;
